import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { BuildingMapDto, BuildingPopupDto } from "../models/building-map.model";
import { ResponsePackage } from "shared-lib";
import { AssetStatusEnum } from "../models/asset-status.model";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root',
})
export class BuildingService {
    private pathApi: string;
    constructor(private http: HttpClient, private config: AppConfig) {
        this.pathApi = this.config.setting['pathApi'] + 'building/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getPopupInfo(id: number) {
        return this.http.get<ResponsePackage<BuildingPopupDto>>(`${this.pathApi}getPopupInfo/${id}`, { headers: this.headers, observe: 'response' });
    }

    getMapDetails(id: number) {
        return this.http.get<ResponsePackage<BuildingMapDto>>(`${this.pathApi}getMapDetails/${id}`, { headers: this.headers, observe: 'response' });
    }

    assignBuilding(
        buildingId: number,
        userId: number,
        assetStatus: AssetStatusEnum,
        isFromRejection: boolean
    ) {
        const obj = {
            entityId: buildingId,
            userId: userId,
            assetStatus: assetStatus,
            isFromRejection: isFromRejection,
        };
        return this.http.post<ResponsePackage<string>>(
            `${this.pathApi}assignBuilding`,
            obj,
            { observe: 'response' }
        );
    }

    recall(id: number, recallType: number) {
        const obj = { id: id, recallType: recallType };
        return this.http.post<ResponsePackage<any>>(`${this.pathApi}recall`, obj, {
            headers: this.headers,
            observe: 'response',
        });
    }

    reviewBuilding(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}reviewBuilding`, obj, {
            headers: this.headers,
            observe: 'response',
        });
    }
}